var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-detail",class:_vm.variantClass},[_c('img',{staticClass:"qr-image",attrs:{"src":_vm.qrSrc,"alt":"收款码"}})])}
var staticRenderFns = []

export { render, staticRenderFns }